import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelCsatReviewNotesIndex from './Index.vue';

/**
 * CSAT review notes export, Teletel's own path.
 *
 * The Chatwoot CSAT download stays Enterprise-gated and untouched; this is a
 * separate route, component and endpoint. The controller has shipped since the
 * flows batch - this route is what makes it reachable without a console.
 *
 * Administrators only. The server enforces the same rule, so hiding the route
 * is a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/teletel-csat-review-notes'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'teletel_csat_review_notes',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'teletel_csat_review_notes',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelCsatReviewNotesIndex,
        },
      ],
    },
  ],
};
